module.exports = __webpack_public_path__ + "static/media/referral.359bde39.png";